import * as React from "react";
import {BaseComponent} from "components/BaseComponent/BaseComponent";
import {repository} from "clientInstance";
import {AzureWebSite} from "client/resources";
import BoundField from "components/form/BoundField/BoundField";
import Note from "components/form/Note/Note";
import Text from "components/form/Text/Text";
import Select from "components/form/Select/Select";
import ParseHelper from "utils/ParseHelper/ParseHelper";
import isBound from "components/form/BoundField/isBound";
import {DataBaseComponent} from "components/DataBaseComponent";

interface AzureWebSiteSelectorProps {
    resourceGroupName: string;
    webAppName: string;
    projectId: string;
    localNames: string[];
    isAccountBound: boolean;
    accountId: string;
    resourceGroupError: string;
    webAppNameError: string;
    onResourceGroupChanged(value: string): void;
    onWebAppNameChanged(valud: string): void;
    doBusyTask(action: () => Promise<void>): Promise<boolean>;
}

interface AzureWebSiteSelectorState {
    reset: {
        resourceGroupName: string;
        name: string;
    };
    siteIsBound: boolean;
    sites: AzureWebSite[];
    siteItems: Array<{ value: string, text: string }>;
    selectedSiteIndex: string;
}

class AzureWebSiteSelector extends BaseComponent<AzureWebSiteSelectorProps, AzureWebSiteSelectorState> {
    constructor(props: AzureWebSiteSelectorProps) {
        super(props);
        this.state = {
            reset: {
                resourceGroupName: null,
                name: null
            },
            siteIsBound: isBound(props.webAppName, false),
            sites: [],
            siteItems: [],
            selectedSiteIndex: null
        };
    }

    componentDidMount() {
        if (!this.props.isAccountBound) {
            this.getWebSites(this.props.accountId);
        }
    }

    componentWillReceiveProps(newprops: AzureWebSiteSelectorProps) {
        if (newprops.isAccountBound && !this.state.siteIsBound) {
            this.setState({siteIsBound: true});
        }
        if (!newprops.isAccountBound && newprops.accountId !== this.props.accountId) {
            this.getWebSites(newprops.accountId);
        }
    }

    render() {
        return <div>
            {this.state.siteIsBound && <div>
                <BoundField localNames={this.props.localNames}
                    resetValue={""}
                    projectId={this.props.projectId}>
                    <Text value={this.props.resourceGroupName}
                        onChange={this.props.onResourceGroupChanged}
                        error={this.props.resourceGroupError}
                        label="Resource Group"
                    />
                </BoundField>
                <Note>The Resource Group of your Azure Web App.<br/>If not specified then all Resource Groups are searched.</Note>
            </div>}
            <BoundField localNames={this.props.localNames}
                resetValue={this.props.webAppName}
                projectId={this.props.projectId}
                isBound={this.state.siteIsBound}
                onIsBoundChanged={(value: boolean) => this.setState({siteIsBound: this.props.isAccountBound || value})}
                hideBindButton={this.props.isAccountBound}
                value={this.props.webAppName}
                onChange={this.props.onWebAppNameChanged}>
                <Select value={this.state.selectedSiteIndex}
                    onChange={this.handleSelectedSiteChanged}
                    items={this.state.siteItems}
                    error={this.props.webAppNameError}
                    label="Web app"
                />
            </BoundField>
            <Note>The name of your Azure Web App.</Note>
        </div>;
    }

    private handleSelectedSiteChanged = (value: string) => {
        const index = ParseHelper.safeParseInt(value, null);
        const selectedSite = index !== null ? this.state.sites[index] : null;

        this.props.onResourceGroupChanged(selectedSite ? selectedSite.ResourceGroup : null);
        this.props.onWebAppNameChanged(selectedSite ? selectedSite.Name : null);
        this.setState({selectedSiteIndex: index !== null ? index.toString() : null});
    }

    private resetWebSites() {
        this.setState({sites: []});
    }

    private async getWebSites(accountId: string) {
        this.props.doBusyTask(async () => {
            if (!accountId) {
                this.setState({
                    sites: [],
                    siteItems: [],
                    selectedSiteIndex: null
                });
                return;
            }
            const account = await repository.Accounts.get(accountId);
            const sites = await repository.Accounts.getWebSites(account);

            let selectedSiteIndex: string = null;
            if (this.props.webAppName) {
                const resourceGroupName = this.props.resourceGroupName === undefined ? null : this.props.resourceGroupName;
                const selectedSite = sites.find(s => s.Name === this.props.webAppName && s.ResourceGroup === resourceGroupName);
                if (selectedSite) {
                    const index = sites.indexOf(selectedSite);
                    selectedSiteIndex = index < 0 ? null : index.toString();
                }
            }

            const siteItems = sites.map((site, index) => {
                const details = site.ResourceGroup ? site.ResourceGroup + " " + site.Region : site.Region;
                return {
                    value: index.toString(),
                    text: site.Name + " " + details
                };
            });

            this.setState({
                sites,
                siteItems,
                selectedSiteIndex
            });
        });
    }
}

export default AzureWebSiteSelector;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Actions/azureWebApp/AzureWebSiteSelector.tsx